import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { forkJoin, interval, Observable, Subscription } from 'rxjs';
import { GitlabService } from '../../gitlab.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard-tracked-branches',
  templateUrl: './tracked-branches.component.html',
  styleUrls: ['./tracked-branches.component.css']
})
export class TrackedBranchesComponent implements OnInit {
  @Input()
  gitlabInstanceName: string;

  pipelines: any[] = [];
  intervalSubscription: Subscription;

  constructor(private gitlabService: GitlabService) {
  }


  ngOnInit() {
    this.loadPipelines();

    this.intervalSubscription = interval(30000).subscribe(() => this.loadPipelines());
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loadPipelines();
  }

  ngOnDestroy() {
    this.intervalSubscription.unsubscribe();
  }

  getStages(pipeline): string[] {
    if (pipeline.jobs) {
      return pipeline.jobs.reduce(
        (accumulator, current) => {
          if (!accumulator.some(stage => stage === current.stage)) {
            accumulator.push(current.stage);
          }
          return accumulator;
        }, []);
    }
    else {
      return [];
    }
  }

  getJobs(pipeline, stage): any[] {
    if (pipeline.jobs) {
      return pipeline.jobs.filter(j => j.stage === stage);
    }
    else {
      return [];
    }
  }


  public loadPipelines() {

    if (!this.gitlabInstanceName || this.gitlabInstanceName === '') {
      return;
    }

    this.gitlabService.getTrackedProjectBranches(this.gitlabInstanceName).subscribe(
      trackers => {
        let pipelineObservables = [];
        trackers.forEach(tracker => {
          pipelineObservables.push(this.loadBranchPipelines(tracker));
        });

        forkJoin(pipelineObservables)
          .subscribe((pipelinesArray: any[][]) => {
            this.pipelines = [];
            pipelinesArray.forEach(pipelines => this.pipelines.push(...pipelines));
          });
      }
    )
  }

  untrack(item: any) {
    this.gitlabService.untrackProjectBranch(this.gitlabInstanceName, item.project.id, item.project.name_with_namespace, item.pipeline.ref)
      .subscribe(() => {
        this.pipelines.splice(this.pipelines.find(p => p.id == item.id), 1);
      });
  }

  private loadBranchPipelines(tracker: any): Observable<any[]> {
    return this.gitlabService.getPipelines(this.gitlabInstanceName, tracker.projectId, tracker.branch)
      .pipe(
        map(pipelines => {
          let result = [];
          for (let i = 0; i < pipelines.length; i++) {
            let pipeline = pipelines[i];

            if (i == 0 ||
              pipeline.status === 'running' ||
              ((new Date(pipeline.updated_at).getTime() + 120000) > new Date().getTime())) {

              result.push({
                id: pipeline.id,
                pipeline: pipeline,
                user: pipeline.user,
                commit: pipeline.commit
              });

              this.loadProject(result[result.length - 1]);
              // this.loadJobs(result[result.length - 1]);
              this.loadCommit(result[result.length - 1]);
              this.loadTestReport(result[result.length - 1]);
            }
          }
          return result;
        }),
      );
  }


  private loadJobs(item: any) {
    this.gitlabService.getPipelineJobs(this.gitlabInstanceName, item.pipeline.project_id, item.pipeline.id)
      .subscribe(jobs => item.jobs = jobs);
  }


  private loadTestReport(item: any) {
    this.gitlabService.getPipelineTestReport(this.gitlabInstanceName, item.pipeline.project_id, item.pipeline.id)
      .subscribe(report => item.testReport = report);
  }


  private loadProject(item: any) {
    this.gitlabService.getProject(this.gitlabInstanceName, item.pipeline.project_id)
      .subscribe(project => item.project = project);
  }


  private loadCommit(item: any) {
    this.gitlabService.getCommit(this.gitlabInstanceName, item.pipeline.project_id, item.pipeline.sha)
      .subscribe(commit => item.commit = commit);
  }

}
